import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAccountTransactions, getAccountTransaction, reverseAccountTransaction } from 'api/accountTransactionApi'

export const ACCOUNT_TRANSACTION_QUERY_KEY = 'account-transactions'

export const useAccountTransactions = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_TRANSACTION_QUERY_KEY, params],
    queryFn: () => getAccountTransactions(params),
    enabled,
  })
}

export const useAccountTransaction = (id, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_TRANSACTION_QUERY_KEY, id],
    queryFn: () => getAccountTransaction(id),
    enabled: enabled && !!id,
  })
}

export const useReverseAccountTransaction = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id) => reverseAccountTransaction(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ACCOUNT_TRANSACTION_QUERY_KEY] })
    },
  })
}
